export const getTagsArray = (tags: string) => {
  return tags.split(", ")
}
